import { NavLink } from 'react-router-dom'
import type { ComponentType } from 'react'
import {
  NavAirdropGlyph,
  NavFootballGlyph,
  NavGamesGlyph,
  NavGiftGlyph,
  NavHomeGlyph,
  NavHorseGlyph,
  NavProfileGlyph,
} from '../lucky/NavGlyphs'
import { useT } from '../../contexts/LocaleContext'

type NavItem = {
  to: string
  labelKey: string
  Icon: ComponentType<{ size?: number; className?: string }>
}

const navItems: NavItem[] = [
  { to: '/', labelKey: 'nav.home', Icon: NavHomeGlyph },
  { to: '/games', labelKey: 'nav.games', Icon: NavGamesGlyph },
  { to: '/football', labelKey: 'nav.football', Icon: NavFootballGlyph },
  { to: '/horse', labelKey: 'nav.horse', Icon: NavHorseGlyph },
  { to: '/airdrop', labelKey: 'nav.airdrop', Icon: NavAirdropGlyph },
  { to: '/gift-card', labelKey: 'nav.gift', Icon: NavGiftGlyph },
  { to: '/profile', labelKey: 'nav.profile', Icon: NavProfileGlyph },
]

export default function Navigation() {
  const t = useT()

  return (
    <nav className="lucky-nav" aria-label={t('nav.aria')}>
      <div className="lucky-nav__inner">
        {navItems.map(({ to, labelKey, Icon }) => (
          <NavLink
            key={to}
            to={to}
            end={to === '/'}
            className={({ isActive }) => `lucky-nav__item${isActive ? ' is-on' : ''}`}
          >
            <span className="lucky-nav__glyph" aria-hidden="true">
              <Icon size={22} />
            </span>
            <span className="lucky-nav__label">{t(labelKey)}</span>
          </NavLink>
        ))}
      </div>
    </nav>
  )
}
